import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    getAllGroups,
    getAllFactoriesByGroupID,
    getDescriptionTypesForDropDown,
    GetCopMappingDetails,
    GetCopTypeByGroupIDAndFactory

};
async function getAllGroups() {
    let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}
async function getAllFactoriesByGroupID(groupID) {
    let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    let factoryArray = []
    for (let item of Object.entries(response.data)) {
        factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
    }
    return factoryArray;
}
async function getDescriptionTypesForDropDown() {
    let descriptionTypeArray = [];
    const response = await CommonGet('/api/AccountType/GetAccountDescriptionTypesForDropdown', null);
    Object.entries(response.data).forEach(([_, item]) => {
        descriptionTypeArray[item.accountDescriptionTypeID] = item.accountDescriptionTypeName;
    });
    return descriptionTypeArray;
}

async function GetCopMappingDetails(model) {
    let response = await CommonPost('/api/CopItemMapping/GetCopMappingDetails', null, model);
    return response;
}

async function GetCopTypeByGroupIDAndFactory(factoryID) {
    let response = await CommonGet('/api/CopItemMapping/GetCopTypeByGroupIDAndFactory', 'factoryID=' + parseInt(factoryID));
    let copArray = []
    for (let item of Object.entries(response.data)) {
        copArray[item[1]["accountDescriptionTypeID"]] = item[1]["accountDescriptionTypeName"]
    }
    return copArray;
}